import { signUpEpic } from './signUpEpic';
import { signOutEpic } from './signOutEpic';

export const epics = [signUpEpic, signOutEpic];
